module.exports = __webpack_public_path__ + "static/logo-93406aa32178e3f54e0fbfbca4fe5023.svg";